import { Cloudinary } from '@cloudinary/url-gen'
import { scale } from '@cloudinary/url-gen/actions/resize'

const QWICK_WEBSITE_CLOUD_NAME =
  process.env.GATSBY_CLOUDINARY_CLOUD_NAME_QWICK_WEBSITE || 'qwick-website'

const qwickWebsiteCloudinary = new Cloudinary({
  cloud: { cloudName: QWICK_WEBSITE_CLOUD_NAME },
})

/**
 * The product app's `gigpro` cloud — serves live user/business assets that
 * come from the app's API (ProAvatar, LocationAvatar, Gig, profile OG images).
 * Not for marketing imagery: new site images go through `qwickWebsiteCloudinary`
 * and the `cloudinaryImage` helper.
 */
const gigproCloudinary = new Cloudinary({
  cloud: {
    cloudName: process.env.GATBSY_CLOUDINARY_CLOUD_NAME || 'gigpro',
  },
})

/** @deprecated Prefer the explicit `gigproCloudinary` name; this bare alias exists for older call sites. */
export const cloudinary = gigproCloudinary

export const cloudinaryImage = (publicId: string) =>
  qwickWebsiteCloudinary.image(publicId).format('auto').quality('auto')

/**
 * Delivery URL for a PDF stored in the qwick-website cloud. PDFs live under
 * `documents/` in `assets/` and upload through the same CI flow as images; link
 * to them with this rather than a raw remote URL.
 */
export const cloudinaryDocumentUrl = (publicId: string) =>
  `https://res.cloudinary.com/${QWICK_WEBSITE_CLOUD_NAME}/image/upload/${publicId}.pdf`

/**
 * Low-Quality Image Placeholder URL — a 40px-wide scale painted as a CSS
 * `background-image` while the full image loads. Scaled (not cropped) to keep
 * the source's aspect ratio; no blur, so the source alpha survives. A small
 * transparent border insets the content so its soft upscaled edges tuck under
 * the real image instead of haloing out past a transparent subject.
 */
export const cloudinaryLqipUrl = (publicId: string) =>
  qwickWebsiteCloudinary
    .image(publicId)
    .format('auto')
    .quality('auto:low')
    .resize(scale().width(120))
    .addTransformation('bo_1px_solid_rgb:00000000')
    .toURL()
